import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { FEATURE_INTEREST } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
export const fetchFeatureInterest = (productLevelFilter, isUngated = false) => {
  const fetchFeatureInterestUrl = `${getFullUrl('app-api')}/upgrade-management-service/v1/calculated-features${isUngated ? '/translated' : ''}`;
  const earlyRequest = getEarlyRequesterResult(FEATURE_INTEREST);

  const fetchFeatureInterestPromise = () => http.get(fetchFeatureInterestUrl, {
    query: {
      productLevel: productLevelFilter
    }
  });

  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => fetchFeatureInterestPromise()) : null;
  return earlyRequestWithRetry || fetchFeatureInterestPromise();
};